export default __webpack_public_path__ + "static/media/default.0b51a5cc.svg";